import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import React from 'react';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import { withFormStyles } from '../styles';

const DEFAULT_GROUPS = {
    everyone: 'Everyone',
};

class BooleanMapForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.init();
    }

    init() {
        return {
            values: this.getInitialValues(this.props.policy.value.policy),
            originalValues: this.getInitialValues(
                this.props.policy.value.policy
            ),
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.policy.value.policy !== this.props.policy.value.policy) {
            this.setState(this.init());
        }
    }

    getInitialValues = (policy = {}) => {
        return Object.entries(DEFAULT_GROUPS).map(([key, label]) => ({
            key,
            label,
            value: !!policy[key],
        }));
    };

    handleToggle = key => event => {
        const checked = event.target.checked;
        this.setState(state => {
            const values = state.values.map(item =>
                item.key === key ? { ...item, value: checked } : item
            );
            return { values };
        });
    };

    handleCancel = () => {
        this.setState(state => ({
            values: [...state.originalValues],
        }));
    };

    handleSave = () => {
        const policy = this.state.values.reduce((acc, item) => {
            acc[item.key] = item.value;
            return acc;
        }, {});
        const data = {
            uuid: this.props.policy.uuid,
            enabled: true,
            value: policy,
        };

        this.props.onSave(data);
    };

    render() {
        const { classes, enabled, editable } = this.props;
        const { values } = this.state;
        const disabled = !enabled || !editable;

        return (
            <>
                <div className={classes.booleanMap}>
                    <Typography>Group visibility settings:</Typography>
                    {values.map(item => (
                        <FormControlLabel
                            key={item.key}
                            control={
                                <Switch
                                    disabled={disabled}
                                    checked={item.value}
                                    onChange={this.handleToggle(item.key)}
                                    color="primary"
                                />
                            }
                            label={item.label}
                            labelPlacement="start"
                        />
                    ))}
                </div>
                <div className={classes.excludeSitesActions}>
                    <Button
                        size="small"
                        disabled={disabled}
                        variant="contained"
                        className={classes.button}
                        onClick={this.handleCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        disabled={disabled}
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={this.handleSave}
                    >
                        Save
                    </Button>
                </div>
            </>
        );
    }
}

export default withFormStyles(BooleanMapForm);
